module.exports = {
  sm: "680px",
  md: "960px",
  lg: "1280px",
  xl: "1980px",
};
